/**
 * 运营 - 提成设置（REQ-005 F009 前端，T-019）
 *
 * 三个页签：销售阶梯 / 主管阶梯 / 其他比例（契约 API-015 v1.0.0，T-015 后端已实现）
 * - 销售阶梯：行=挡位，列=达到毛利 / 独立完成% / 他人协助完成% / 转介绍他人协助%（行内编辑，增删行）；
 *   下方附北京提成比例阶梯设置区（同款交互同字段，电销归属地为北京的单子定档用）
 * - 主管阶梯：行=挡位，列=达到毛利 / 提成比例%
 * - 其他比例：协助他人% / 转交后继承% / 北京电销分配比例%（三个输入框，全局单行）
 *
 * % 语义（AC-009-02）：前端展示/提交一律 % 值（如 10=10%），后端负责 ÷100 存小数；前端不二次换算。
 * 保存规则：阶梯为"全量替换"（POST body=整个挡位列表，增删改=列表变化）；保存成功 INCR 配置版本号后重新 GET 回显。
 * 校验：前端行内先提示（挡位递增/首档 0/比例 0~100%/至少 1 档），后端兜底（702 校验失败展示后端 msg）。
 */
<template>
  <div class="commission-setting-page">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="page-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/oms/customerSignOrder' }">运营</el-breadcrumb-item>
      <el-breadcrumb-item>提成比例设置</el-breadcrumb-item>
      <el-breadcrumb-item>{{ currentPageName }}</el-breadcrumb-item>
    </el-breadcrumb>

    <el-tabs v-model="activeTab" type="border-card" v-loading="loading">
      <!-- ==================== 销售比例设置（菜单独立页，仅销售阶梯） ==================== -->
      <el-tab-pane v-if="activeTab === 'sales'" label="销售比例设置" name="sales">
        <!-- BUG-005 修复: 表格单元格内 el-form-item 必须包在 el-form 内, 否则渲染失败(el-input 不渲染) -->
        <el-form class="ladder-form">
        <div class="tab-toolbar">
          <el-button type="primary" size="small" icon="el-icon-plus" @click="addSalesRow">新增挡位</el-button>
          <el-button type="success" size="small" :loading="savingSales" @click="saveSalesLadder">保存销售阶梯</el-button>
          <span class="tab-tip">比例填 % 值（如 10 表示 10%），保存后由后端换算存储</span>
        </div>
        <el-table :data="salesLadder" border size="small" empty-text="暂无挡位，请点击「新增挡位」配置">
          <el-table-column label="达到的毛利" width="220">
            <template slot-scope="{ row }">
              <el-form-item :error="(row._err && row._err.reachGrossProfit) || ''" class="cell-form-item">
                <el-input v-model="row.reachGrossProfit" placeholder="挡位值，如 0 / 5000" clearable></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="独立完成 %" width="200">
            <template slot-scope="{ row }">
              <el-form-item :error="(row._err && row._err.independentRate) || ''" class="cell-form-item">
                <el-input v-model="row.independentRate" placeholder="0~100" clearable>
                <template slot="suffix">%</template>
              </el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="他人协助完成 %" width="200">
            <template slot-scope="{ row }">
              <el-form-item :error="(row._err && row._err.assistCompleteRate) || ''" class="cell-form-item">
                <el-input v-model="row.assistCompleteRate" placeholder="0~100" clearable>
                <template slot="suffix">%</template>
              </el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="转介绍他人协助 %" width="200">
            <template slot-scope="{ row }">
              <el-form-item :error="(row._err && row._err.referralAssistRate) || ''" class="cell-form-item">
                <el-input v-model="row.referralAssistRate" placeholder="0~100" clearable>
                <template slot="suffix">%</template>
              </el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="{ $index }">
              <el-button type="text" size="small" @click="removeLadderRow(salesLadder, $index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        </el-form>

        <!-- 北京提成比例阶梯：结构/交互同上方销售阶梯；转介绍比例可设置但计算不使用 -->
        <el-divider content-position="left">北京提成比例阶梯</el-divider>
        <el-form class="ladder-form">
        <div class="tab-toolbar">
          <el-button type="primary" size="small" icon="el-icon-plus" @click="addBeijingRow">新增挡位</el-button>
          <el-button type="success" size="small" :loading="savingBeijing" @click="saveBeijingLadder">保存北京阶梯</el-button>
          <span class="tab-tip">电销归属地为北京的单子定档用；比例填 % 值（如 10 表示 10%），保存后由后端换算存储</span>
        </div>
        <el-table :data="beijingLadder" border size="small" empty-text="暂无挡位，请点击「新增挡位」配置">
          <el-table-column label="达到的毛利" width="220">
            <template slot-scope="{ row }">
              <el-form-item :error="(row._err && row._err.reachGrossProfit) || ''" class="cell-form-item">
                <el-input v-model="row.reachGrossProfit" placeholder="挡位值，如 0 / 5000" clearable></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="独立完成 %" width="200">
            <template slot-scope="{ row }">
              <el-form-item :error="(row._err && row._err.independentRate) || ''" class="cell-form-item">
                <el-input v-model="row.independentRate" placeholder="0~100" clearable>
                <template slot="suffix">%</template>
              </el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="他人协助完成 %" width="200">
            <template slot-scope="{ row }">
              <el-form-item :error="(row._err && row._err.assistCompleteRate) || ''" class="cell-form-item">
                <el-input v-model="row.assistCompleteRate" placeholder="0~100" clearable>
                <template slot="suffix">%</template>
              </el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="转介绍他人协助 %" width="200">
            <template slot-scope="{ row }">
              <el-form-item :error="(row._err && row._err.referralAssistRate) || ''" class="cell-form-item">
                <el-input v-model="row.referralAssistRate" placeholder="0~100" clearable>
                <template slot="suffix">%</template>
              </el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="{ $index }">
              <el-button type="text" size="small" @click="removeLadderRow(beijingLadder, $index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        </el-form>
      </el-tab-pane>

      <!-- ==================== 主管比例设置（菜单独立页，仅主管阶梯） ==================== -->
      <el-tab-pane v-if="activeTab === 'leader'" label="主管比例设置" name="leader">
        <!-- BUG-005 修复: 同销售阶梯, 必须包 el-form -->
        <el-form class="ladder-form">
        <div class="tab-toolbar">
          <el-button type="primary" size="small" icon="el-icon-plus" @click="addLeaderRow">新增挡位</el-button>
          <el-button type="success" size="small" :loading="savingLeader" @click="saveLeaderLadder">保存主管阶梯</el-button>
          <span class="tab-tip">比例填 % 值（如 10 表示 10%），保存后由后端换算存储</span>
        </div>
        <el-table :data="leaderLadder" border size="small" empty-text="暂无挡位，请点击「新增挡位」配置">
          <el-table-column label="达到的毛利" width="220">
            <template slot-scope="{ row }">
              <el-form-item :error="(row._err && row._err.reachGrossProfit) || ''" class="cell-form-item">
                <el-input v-model="row.reachGrossProfit" placeholder="挡位值，如 0 / 10000" clearable></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="提成比例 %" width="200">
            <template slot-scope="{ row }">
              <el-form-item :error="(row._err && row._err.commissionRate) || ''" class="cell-form-item">
                <el-input v-model="row.commissionRate" placeholder="0~100" clearable>
                <template slot="suffix">%</template>
              </el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="{ $index }">
              <el-button type="text" size="small" @click="removeLadderRow(leaderLadder, $index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        </el-form>
      </el-tab-pane>

      <!-- ==================== 其他比例设置（菜单独立页，仅其他比例） ==================== -->
      <el-tab-pane v-if="activeTab === 'ratio'" label="其他比例设置" name="ratio">
        <el-form :model="ratio" label-width="200px" size="small" class="ratio-form">
          <el-form-item
            label="协助他人时比例 %"
            :error="ratioErr.assistOthersRate"
          >
            <el-input
              v-model="ratio.assistOthersRate"
              placeholder="0~100，如 5 表示 5%"
              clearable
              style="width: 300px"
            >
              <template slot="suffix">%</template>
            </el-input>
          </el-form-item>
          <el-form-item
            label="转交后继承的比例 %"
            :error="ratioErr.transferInheritRate"
          >
            <el-input
              v-model="ratio.transferInheritRate"
              placeholder="0~100，如 50 表示 50%"
              clearable
              style="width: 300px"
            >
              <template slot="suffix">%</template>
            </el-input>
          </el-form-item>
          <el-form-item
            label="北京电销分配比例 %"
            :error="ratioErr.bjPhoneAllocRate"
          >
            <el-input
              v-model="ratio.bjPhoneAllocRate"
              placeholder="0~100，如 50 表示 50%"
              clearable
              style="width: 300px"
            >
              <template slot="suffix">%</template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="success" size="small" :loading="savingRatio" @click="saveRatio">保存其他比例</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {
  getSalesCommissionLadder,
  saveSalesCommissionLadder,
  getBeijingCommissionLadder,
  saveBeijingCommissionLadder,
  getLeaderCommissionLadder,
  saveLeaderCommissionLadder,
  getCommissionRatio,
  saveCommissionRatio
} from "../../api/userMG";

export default {
  name: "commissionSetting",
  data() {
    return {
      activeTab: "sales",
      loading: false,
      // 销售阶梯：{ reachGrossProfit, independentRate, assistCompleteRate, referralAssistRate }
      salesLadder: [],
      savingSales: false,
      // 北京阶梯：字段同销售阶梯；转介绍比例为保留字段，可设置但计算不使用
      beijingLadder: [],
      savingBeijing: false,
      // 主管阶梯：{ reachGrossProfit, commissionRate }
      leaderLadder: [],
      savingLeader: false,
      // 其他比例（全局单行，未初始化 GET 返回 null → 兜底空对象）
      ratio: {
        assistOthersRate: null,
        transferInheritRate: null,
        bjPhoneAllocRate: null
      },
      ratioErr: {
        assistOthersRate: "",
        transferInheritRate: "",
        bjPhoneAllocRate: ""
      },
      savingRatio: false
    };
  },
  created() {
    // 菜单三页化（2026-08-27 用户需求）：按路由定位到对应配置页，每页只显示一个 tab
    this.activeTab = this.tabFromRoute(this.$route.path);
    this.loadAll();
  },
  watch: {
    // 三个路由复用同一组件实例, created 不会重跑 → 路由切换时必须同步 activeTab
    '$route.path'(path) {
      this.activeTab = this.tabFromRoute(path);
    }
  },
  computed: {
    // 面包屑当前页名（与菜单子项一致）
    currentPageName() {
      const nameMap = {
        sales: '销售比例设置',
        leader: '主管比例设置',
        ratio: '其他比例设置'
      };
      return nameMap[this.activeTab] || '';
    }
  },
  methods: {
    // 路由 path → 页签名（菜单三页化）
    tabFromRoute(path) {
      const tabMap = {
        '/oms/salesRatioSetting': 'sales',
        '/oms/leaderRatioSetting': 'leader',
        '/oms/otherRatioSetting': 'ratio',
        '/oms/commissionSetting': 'sales' // 兼容旧入口
      };
      return tabMap[path] || 'sales';
    },
    // ==================== 数据加载 ====================
    loadAll() {
      this.loading = true;
      Promise.all([this.loadSalesLadder(), this.loadBeijingLadder(), this.loadLeaderLadder(), this.loadRatio()])
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    async loadSalesLadder() {
      try {
        const res = await getSalesCommissionLadder();
        if (res && res.code === 0) {
          this.salesLadder = (res.data || []).map((r) => ({
            reachGrossProfit: r.reachGrossProfit,
            independentRate: r.independentRate,
            assistCompleteRate: r.assistCompleteRate,
            referralAssistRate: r.referralAssistRate
          }));
        } else {
          this.$message.error((res && res.msg) || "销售阶梯加载失败");
        }
      } catch (e) {
        this.$message.error("销售阶梯加载失败");
      }
    },
    async loadBeijingLadder() {
      try {
        const res = await getBeijingCommissionLadder();
        if (res && res.code === 0) {
          this.beijingLadder = (res.data || []).map((r) => ({
            reachGrossProfit: r.reachGrossProfit,
            independentRate: r.independentRate,
            assistCompleteRate: r.assistCompleteRate,
            referralAssistRate: r.referralAssistRate
          }));
        } else {
          this.$message.error((res && res.msg) || "北京阶梯加载失败");
        }
      } catch (e) {
        this.$message.error("北京阶梯加载失败");
      }
    },
    async loadLeaderLadder() {
      try {
        const res = await getLeaderCommissionLadder();
        if (res && res.code === 0) {
          this.leaderLadder = (res.data || []).map((r) => ({
            reachGrossProfit: r.reachGrossProfit,
            commissionRate: r.commissionRate
          }));
        } else {
          this.$message.error((res && res.msg) || "主管阶梯加载失败");
        }
      } catch (e) {
        this.$message.error("主管阶梯加载失败");
      }
    },
    async loadRatio() {
      try {
        const res = await getCommissionRatio();
        if (res && res.code === 0) {
          const d = res.data || {};
          this.ratio = {
            assistOthersRate: d.assistOthersRate != null ? d.assistOthersRate : null,
            transferInheritRate: d.transferInheritRate != null ? d.transferInheritRate : null,
            bjPhoneAllocRate: d.bjPhoneAllocRate != null ? d.bjPhoneAllocRate : null
          };
        } else {
          this.$message.error((res && res.msg) || "其他比例加载失败");
        }
      } catch (e) {
        this.$message.error("其他比例加载失败");
      }
    },

    // ==================== 阶梯行操作 ====================
    addSalesRow() {
      this.salesLadder.push({
        reachGrossProfit: this.salesLadder.length === 0 ? 0 : "",
        independentRate: "",
        assistCompleteRate: "",
        referralAssistRate: ""
      });
    },
    addLeaderRow() {
      this.leaderLadder.push({
        reachGrossProfit: this.leaderLadder.length === 0 ? 0 : "",
        commissionRate: ""
      });
    },
    addBeijingRow() {
      this.beijingLadder.push({
        reachGrossProfit: this.beijingLadder.length === 0 ? 0 : "",
        independentRate: "",
        assistCompleteRate: "",
        referralAssistRate: ""
      });
    },
    removeLadderRow(list, index) {
      if (list.length <= 1) {
        this.$message.warning("至少保留 1 个挡位");
        return;
      }
      list.splice(index, 1);
    },

    // ==================== 校验（与后端一致，前端先提示） ====================
    // 返回 true=通过；false=有错误（已行内标红）
    validateLadderRows(list, type) {
      list.forEach((row) => {
        if (row._err) {
          this.$delete(row, "_err");
        }
      });
      if (!list.length) {
        this.$message.warning("请至少配置 1 个挡位");
        return false;
      }
      const rateKeys =
        type === "sales"
          ? ["independentRate", "assistCompleteRate", "referralAssistRate"]
          : ["commissionRate"];
      let prev = null;
      let hasError = false;
      list.forEach((row, i) => {
        const err = {};
        const gp = Number(row.reachGrossProfit);
        const gpEmpty = row.reachGrossProfit === "" || row.reachGrossProfit === null || row.reachGrossProfit === undefined;
        if (gpEmpty || isNaN(gp)) {
          err.reachGrossProfit = "达到毛利必填";
        } else if (i === 0) {
          if (gp !== 0) {
            err.reachGrossProfit = "首个挡位（起点）必须为 0";
          }
          prev = gp;
        } else if (gp <= prev) {
          err.reachGrossProfit = "挡位须单调递增且不重复";
        } else {
          prev = gp;
        }
        rateKeys.forEach((k) => {
          const v = row[k];
          const num = Number(v);
          const empty = v === "" || v === null || v === undefined;
          if (empty || isNaN(num)) {
            err[k] = "比例必填";
          } else if (num < 0 || num > 100) {
            err[k] = "比例须在 0%~100% 之间";
          }
        });
        if (Object.keys(err).length) {
          this.$set(row, "_err", err);
          hasError = true;
        }
      });
      if (hasError) {
        this.$message.warning("请修正表格中的错误后再保存");
      }
      return !hasError;
    },

    // ==================== 保存 ====================
    async saveBeijingLadder() {
      if (!this.validateLadderRows(this.beijingLadder, "sales")) {
        return;
      }
      this.savingBeijing = true;
      try {
        const items = this.beijingLadder.map((r) => ({
          reachGrossProfit: Number(r.reachGrossProfit),
          independentRate: Number(r.independentRate),
          assistCompleteRate: Number(r.assistCompleteRate),
          referralAssistRate: Number(r.referralAssistRate)
        }));
        const res = await saveBeijingCommissionLadder(items);
        if (res && res.code === 0) {
          this.$message.success("北京阶梯保存成功");
          await this.loadBeijingLadder();
        } else {
          this.$message.error((res && res.msg) || "保存失败");
        }
      } catch (e) {
        this.$message.error("保存失败，请重试");
      } finally {
        this.savingBeijing = false;
      }
    },
    async saveSalesLadder() {
      if (!this.validateLadderRows(this.salesLadder, "sales")) {
        return;
      }
      this.savingSales = true;
      try {
        const items = this.salesLadder.map((r) => ({
          reachGrossProfit: Number(r.reachGrossProfit),
          independentRate: Number(r.independentRate),
          assistCompleteRate: Number(r.assistCompleteRate),
          referralAssistRate: Number(r.referralAssistRate)
        }));
        const res = await saveSalesCommissionLadder(items);
        if (res && res.code === 0) {
          this.$message.success("销售阶梯保存成功");
          await this.loadSalesLadder();
        } else {
          this.$message.error((res && res.msg) || "保存失败");
        }
      } catch (e) {
        this.$message.error("保存失败，请重试");
      } finally {
        this.savingSales = false;
      }
    },
    async saveLeaderLadder() {
      if (!this.validateLadderRows(this.leaderLadder, "leader")) {
        return;
      }
      this.savingLeader = true;
      try {
        const items = this.leaderLadder.map((r) => ({
          reachGrossProfit: Number(r.reachGrossProfit),
          commissionRate: Number(r.commissionRate)
        }));
        const res = await saveLeaderCommissionLadder(items);
        if (res && res.code === 0) {
          this.$message.success("主管阶梯保存成功");
          await this.loadLeaderLadder();
        } else {
          this.$message.error((res && res.msg) || "保存失败");
        }
      } catch (e) {
        this.$message.error("保存失败，请重试");
      } finally {
        this.savingLeader = false;
      }
    },
    async saveRatio() {
      this.ratioErr = { assistOthersRate: "", transferInheritRate: "", bjPhoneAllocRate: "" };
      let hasError = false;
      ["assistOthersRate", "transferInheritRate", "bjPhoneAllocRate"].forEach((k) => {
        const v = this.ratio[k];
        const num = Number(v);
        const empty = v === "" || v === null || v === undefined;
        if (empty || isNaN(num)) {
          this.ratioErr[k] = "比例必填";
          hasError = true;
        } else if (num < 0 || num > 100) {
          this.ratioErr[k] = "比例须在 0%~100% 之间";
          hasError = true;
        }
      });
      if (hasError) {
        return;
      }
      this.savingRatio = true;
      try {
        const res = await saveCommissionRatio({
          assistOthersRate: Number(this.ratio.assistOthersRate),
          transferInheritRate: Number(this.ratio.transferInheritRate),
          bjPhoneAllocRate: Number(this.ratio.bjPhoneAllocRate)
        });
        if (res && res.code === 0) {
          this.$message.success("其他比例保存成功");
          await this.loadRatio();
        } else {
          this.$message.error((res && res.msg) || "保存失败");
        }
      } catch (e) {
        this.$message.error("保存失败，请重试");
      } finally {
        this.savingRatio = false;
      }
    }
  }
};
</script>

<style scoped>
.commission-setting-page {
  padding: 10px;
}
.page-breadcrumb {
  margin-bottom: 14px;
}
.tab-toolbar {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}
.tab-tip {
  margin-left: 12px;
  color: #909399;
  font-size: 12px;
}
.cell-form-item {
  margin-bottom: 0;
}
.ratio-form {
  max-width: 640px;
  padding-top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/oms/commissionSetting.vue